import React, { memo, forwardRef } from "react";
const SvgCapitalR = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M13.43 14.93h2.06c.36 0 .72-.027 1.08-.08.36-.053.68-.153.96-.3.293-.147.534-.353.72-.62.187-.28.28-.633.28-1.06 0-.387-.087-.7-.26-.94a1.9 1.9 0 00-.66-.6 2.766 2.766 0 00-.92-.3 6.202 6.202 0 00-.98-.08h-2.28v3.98zm1.84 2.06h-1.84v4.76c0 .307-.046.553-.14.74a1.347 1.347 0 01-.34.42.814.814 0 01-.4.2c-.147.04-.273.06-.38.06-.107 0-.233-.02-.38-.06a.938.938 0 01-.42-.2 1.516 1.516 0 01-.32-.42c-.093-.187-.14-.433-.14-.74V10.33c0-1 .5-1.5 1.5-1.5h3.42c.667 0 1.313.073 1.94.22.627.133 1.18.36 1.66.68.494.32.887.74 1.18 1.26.294.52.44 1.153.44 1.9 0 1.027-.293 1.867-.88 2.52-.573.64-1.36 1.073-2.36 1.3l2.98 4.38c.107.16.18.313.22.46a1.183 1.183 0 01-.28 1.28c-.227.227-.52.34-.88.34-.173 0-.36-.047-.56-.14-.186-.093-.366-.273-.54-.54l-3.48-5.5z"
      />
    </svg>
  );
});
SvgCapitalR.displayName = "SvgCapitalR";
const MemoForwardRef = memo(SvgCapitalR);
export default MemoForwardRef;
